import { ISystemState } from "~/lib/types/maintenance.type";
import { apiClient } from "~/lib/utils/axios";

export const readSystemState = () => {
  return apiClient
    .get(`/maintenance/maintenance/system-state`)
    .then((response) => response.data as ISystemState);
};
